<template>
  <el-dialog
    class="rc-dialog"
    title="角色授权"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <div class="Treetree">
      <el-tree
        ref="tree"
        :data="sqTreeList"
        :props="defaultPropsSQ"
        show-checkbox
        node-key="apiId"
        :default-checked-keys="nodeID"
        @check-change="getMenuID"
      ></el-tree>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn title="取消" @click.native="closeFrom"></butn>
      <butn btntype="primary" title="确定" @click.native="createData"></butn>
    </div>
  </el-dialog>
</template>

<script>
import Bus from "./Bus.js";
import butn from "@/components/button/index";
import { roleUpdate } from "@/api/role";
import { menuTree } from "@/api/menu";
function mergeLeaf(item) {
  if (!item.son) return item;
  return { ...item.itself, children: item.son.map(mergeLeaf) };
}
export default {
  name: "Warrant",
  components: { butn },
  data() {
    return {
      size: "small",
      Bus,
      rules: {},
      curdForm: {},
      CUFlag: false,
      nodeID: [],
      sqTreeList: [],
      defaultPropsSQ: {
        //角色授权树形-结构
        children: "children",
        label: "name"
      },
      menusID: [],
      itemKey: {},
      tree: []
    };
  },
  watch: {},
  created() {},
  methods: {
    getMenuID() {
      var checkedKeys = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys()); // 所有被选中的节点的 key 所组成的数组数据
      this.menusID = checkedKeys.map(id => ({ apiId: id }));
    },
    warractLst(item) {
      this.itemKey = item;
      var menuList = item.menus;
      let that = this;
      setTimeout(function() {
        menuList.forEach(value => {
          that.$refs.tree.setChecked(value, true, false);
        });
      }, 100);
    },
    createData() {
      var checkedKeys = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      var menusID = checkedKeys.map(id => ({ apiId: id }));
      let para = {
        menus: menusID,
        roleId: this.itemKey.roleId,
        roleCode: this.itemKey.roleCode,
        index: this.itemKey.index
      };

      this.loading = true;
      roleUpdate(para).then(res => {
        this.loading = false;
        if (res && res.code == 0) {
          this.$message({
            message: res.message,
            type: "success"
          });
          this.CUFlag = false;
          this.$emit("searchl", para);
        }
      });
    },
    closeFrom() {
      this.CUFlag = false;
      this.nodeID = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    loseDialog() {
      // 点击关闭 数据重置
      this.nodeID = [];
      this.CUFlag = false;
      this.$refs.tree.setCheckedKeys([]);
    },
    // treeInit() {
    //   this.sqTreeList = Bus.menuTree;
    // },
    initTree(item) {
      menuTree().then(({ data }) => {
        this.sqTreeList = data.map(mergeLeaf);
        this.warractLst(item);
      });
    }
  },
  mounted() {
    var that = this;
    Bus.$on("getMenuID", function(item) {
      that.initTree(item);
      that.CUFlag = true;
    });
  }
};
</script>
